import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Qué recibo exactamente cuando compro?',
  answer: 'Recibes el libro digital en PDF + los 5 bonos de implementación inmediata.\n\nTodo llega directo a tu correo en segundos y puedes leerlo desde tu teléfono, tablet o computadora.'
}, {
  question: '¿Necesito mucho tiempo para leerlo?',
  answer: 'No.\n\nEl libro está diseñado para cuidadores agotados: capítulos cortos, ejercicios breves y herramientas que puedes aplicar incluso en días difíciles.'
}, {
  question: '¿Y si no soy cuidadora a tiempo completo?',
  answer: 'También es para ti.\n\nEste libro acompaña a quienes cuidan aunque sea un poquito, aunque no vivan con la persona, aunque solo apoyen en momentos clave.\n\nSi el cuidado te pesa, te preocupa o te desordena emocionalmente, este libro te sirve.'
}, {
  question: '¿Sirve si no cuido a mis padres, sino a otra persona?',
  answer: 'Sí.\n\nEl libro está pensado para cualquier persona que sostiene emocionalmente a alguien más:\n\n• abuelos\n• tíos\n• hermanos\n• pareja\n• hijos con desafíos emocionales o de salud\n• familiares con condiciones crónicas\n• personas que dependen de ti en lo cotidiano\n\nNo importa el vínculo.\n\nSi estás cuidando a alguien y sientes que te estás quedando sin aire, este libro te acompaña sin juzgar.'
}, {
  question: '¿Qué pasa si mi familiar no quiere cambiar o no acepta ayuda?',
  answer: 'El libro no intenta cambiar a tu familiar.\n\nTe ayuda a cambiar tu forma de sostener, poner límites sin culpa, comunicarte con más claridad y recuperar energía aunque la otra persona siga igual.'
}, {
  question: '¿Cómo recibo el libro?',
  answer: 'Apenas haces la compra, te llega un correo con el enlace de descarga inmediata.\n\nNo tienes que esperar nada.'
}, {
  question: '¿Y si no me gusta o no me ayuda?',
  answer: 'Tienes una garantía de 7 días.\n\nSi no sientes alivio, claridad o acompañamiento, te devuelvo tu dinero sin preguntas.\n\nTu bienestar es primero.'
}, {
  question: '¿Puedo leerlo desde mi celular?',
  answer: 'Sí.\n\nTodo está en PDF, optimizado para que puedas leerlo desde tu teléfono sin complicaciones.'
}, {
  question: '¿Esto reemplaza terapia?',
  answer: 'No.\n\nEste libro es un acompañamiento emocional y práctico, no un tratamiento clínico.\n\nPero sí puede ayudarte a ordenar tus emociones, entender lo que sientes y comunicarte mejor mientras buscas o recibes apoyo profesional.'
}, {
  question: '¿Cuánto tiempo tengo acceso?',
  answer: 'Para siempre.\n\nUna vez descargado, es tuyo. Puedes imprimirlo, releerlo y usar los ejercicios cada vez que lo necesites.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 px-4 bg-cream" data-id="element-163">
      <div className="max-w-4xl mx-auto" data-id="element-164">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-165">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy" data-id="element-166">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-2" data-id="element-167">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="border-b border-navy/10" data-id="element-168">
              <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between text-left py-5 focus:outline-none group" aria-expanded={openIndex === index} data-id="element-169">
                <span className="text-lg md:text-xl font-serif font-bold text-navy group-hover:text-terracotta transition-colors pr-8" data-id="element-170">
                  {faq.question}
                </span>
                <ChevronDown className={`w-6 h-6 text-navy/50 shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-171" />
              </button>
              <AnimatePresence data-id="element-172">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-173">
                    <div className="pb-6 text-navy/80 leading-relaxed whitespace-pre-wrap text-base md:text-lg" data-id="element-174">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}